import SummitAttendeeFunds from './SummitAttendeeFunds'

export default SummitAttendeeFunds
